<template>
    <v-container fill-height fluid class="app-screen-bg">
        <v-row class="flex  align-center align-content-center">
            <v-col class="ma-0 pa-0 col-2 col-md-4" />
            <v-col class="ma-0 pa-0 col-8 col-md-4">
                <v-card
                    width="400"
                    height="400"
                    class="justify-center align-center align-content-center"
                >
                    <v-card-title
                        primary-title class="justify-center"
                    > {{ $t('login.login.title') }}
                    </v-card-title>
                    <v-card-text
                        class="text-center justify-center align-center black--text"
                    >
                        <v-form @submit.prevent="login">
                            <v-text-field
                                v-model="name"
                                :label="$t('login.login.nameLabel')"
                                required
                                color=" black--text"
                            ></v-text-field>
                            <v-text-field
                                v-model="password"
                                :label="$t('login.login.passwordLabel')"
                                required
                                color=" black--text"
                                type="password"
                            ></v-text-field>

                            <v-btn
                                class="mr-4"
                                type="submit"
                                :loading="isLoading"
                                :disabled="isLoading"
                            >
                                {{ $t('login.login.submitButton') }}
                            </v-btn>

                            <div v-if="error" :class="{'white--text': $vuetify.theme.dark}">
                                {{error}}
                            </div>
                        </v-form>
                    </v-card-text>

                </v-card>
            </v-col>
            <v-col class="ma-0 pa-0 col-2 col-md-4" />
        </v-row>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        data() {
            return {
                name: "",
                password: "",
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'user/isLoading',
                error: 'user/error',
            }),
        },
        watch: {
        },
        created() {
        },
        methods: {
            ...mapActions({
                loginUser: 'user/login',
                resetError: 'user/resetError',
            }),
            login(){
                this.resetError();
                // Presmerovani na Journey uz resi samo user/login (viz
                // store/modules/user/actions.js) - volat tu router.push()
                // znovu vedlo na Vue Router "NavigationDuplicated" (push na
                // stejnou routu, na kterou uz store akce presmerovala/presmerovava),
                // ktery nikdo nechytal a skoncil jako unhandled rejection
                // (nahlaseno uzivatelem 2026-08-04 po zavedeni globalniho
                // error safety-netu, ktery to zacal viditelne hlasit).
                this.loginUser({accName: this.name, password: this.password}).catch(() => {
                    // Chyba uz je zobrazena inline pres user/error (viz
                    // sablona nize) - .catch() je tu jen proto, aby loginUser()
                    // rejection nedopadlo jako unhandledrejection a nevyvolalo
                    // navic i globalni toast (viz main.js safety-net).
                });
            },
        },
    }
</script>

